import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { emailWishlist, getShareWishlistLink, markListPublic } from '../index';
import { t } from '../../theme/locales';
export const WishlistShare = ({ lid , lname  })=>{
    const [link, setLink] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [fromName, setFromName] = useState('');
    const [note, setNote] = useState('');
    const [submitError, setSubmitError] = useState(null);
    const [submitResponse, setSubmitResponse] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(()=>{
        const createShareableLink = async ()=>{
            try {
                if (!window._swat) {
                    console.error('Swym API not initialized');
                    return;
                }
                const markPublicResponse = await markListPublic(lid, window._swat);
                if (!markPublicResponse || typeof markPublicResponse !== 'object') {
                    console.error('Unexpected response from markListPublic:', markPublicResponse);
                    return;
                }
                const requestLink = await getShareWishlistLink(lid, window._swat);
                if (requestLink && typeof requestLink === 'string') {
                    setLink(requestLink);
                }
            } catch (error) {
                console.error('Error creating shareable link:', error);
            }
        };
        createShareableLink();
    }, [
        lid
    ]);
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setSubmitError(null);
        setSubmitResponse(null);
        if (!window._swat) {
            setSubmitError(t('wishlist.wishlist_service_not_ready'));
            return;
        }
        setIsSubmitting(true);
        try {
            await emailWishlist(lid, window._swat, emailAddress, fromName, note);
            setSubmitResponse(t('wishlist.wishlist_email_sent'));
        } catch (error) {
            setSubmitError(t('wishlist.wishlist_email_failed'));
        } finally{
            setIsSubmitting(false);
        }
    };
    return h('div', {
        className: 'modal__panel--share-wishlist'
    }, [
        h('div', {
            className: 'wishlist-modal__form'
        }, [
            h('div', {
                className: 'wishlist-modal__header'
            }, [
                h('p', {
                    className: 'wishlist-modal__title'
                }, [
                    `${t('wishlist.share_your')} `,
                    h('span', {}, lname)
                ])
            ]),
            h('form', {
                onSubmit: handleSubmit
            }, [
                h('div', {
                    className: 'wishlist-modal__form-group'
                }, [
                    h('label', {
                        htmlFor: 'email',
                        className: 'wishlist-modal__label'
                    }, [
                        t('wishlist.recipient_email')
                    ]),
                    h('input', {
                        type: 'email',
                        id: 'email',
                        name: 'email',
                        className: 'wishlist-modal__input',
                        placeholder: t('wishlist.recipient_email_placeholder'),
                        value: emailAddress,
                        required: true,
                        onInput: (event)=>{
                            const target = event.currentTarget;
                            setEmailAddress(target.value);
                        }
                    })
                ]),
                h('div', {
                    className: 'wishlist-modal__form-group'
                }, [
                    h('label', {
                        htmlFor: 'fromName',
                        className: 'wishlist-modal__label'
                    }, [
                        t('wishlist.your_name')
                    ]),
                    h('input', {
                        type: 'text',
                        id: 'fromName',
                        name: 'fromName',
                        className: 'wishlist-modal__input',
                        placeholder: t('wishlist.your_name_placeholder'),
                        value: fromName,
                        onInput: (event)=>{
                            const target = event.currentTarget;
                            setFromName(target.value);
                        }
                    })
                ]),
                h('div', {
                    className: 'wishlist-modal__form-group'
                }, [
                    h('label', {
                        htmlFor: 'note',
                        className: 'wishlist-modal__label'
                    }, [
                        t('wishlist.your_message')
                    ]),
                    h('textarea', {
                        id: 'note',
                        name: 'note',
                        className: 'wishlist-modal__textarea',
                        placeholder: t('wishlist.your_message_placeholder'),
                        rows: 4,
                        value: note,
                        onInput: (event)=>{
                            const target = event.currentTarget;
                            setNote(target.value);
                        }
                    })
                ]),
                h('button', {
                    type: 'submit',
                    className: 'wishlist-modal__submit-btn o-button',
                    disabled: isSubmitting
                }, isSubmitting ? t('wishlist.sending') : t('wishlist.email_wishlist')),
                submitError && h('p', {
                    className: 'wishlist-modal__form-error',
                    role: 'alert',
                    'aria-live': 'assertive'
                }, [
                    submitError
                ]),
                submitResponse && h('p', {
                    className: 'wishlist-modal__form-success',
                    role: 'status',
                    'aria-live': 'polite'
                }, [
                    submitResponse
                ])
            ])
        ]),
        h('div', {
            className: 'wishlist-modal__footer'
        }, [
            h('div', {
                className: 'wishlist-modal__form-group'
            }, [
                h('label', {
                    className: 'wishlist-modal__label',
                    htmlFor: 'share-link'
                }, t('wishlist.share_link')),
                h('div', {
                    className: 'wishlist-modal__share__input-group-inline'
                }, [
                    h('input', {
                        type: 'text',
                        id: 'share-link',
                        className: 'wishlist-modal__share-link',
                        value: link,
                        readOnly: true
                    }),
                    h('button', {
                        type: 'button',
                        className: 'wishlist-modal__copy-btn o-button',
                        onClick: (e)=>{
                            navigator.clipboard.writeText(link).then(()=>{
                                const target = e.target;
                                if (target) {
                                    target.textContent = t('wishlist.copied');
                                }
                            });
                        }
                    }, [
                        h('span', {
                            className: 'wishlist-modal__copy-icon'
                        }, [
                            h('svg', {
                                width: '16',
                                height: '16',
                                viewBox: '0 0 16 16',
                                fill: 'none',
                                xmlns: 'http://www.w3.org/2000/svg'
                            }, [
                                h('g', {
                                    clipPath: 'url(#clip0_15082_397)'
                                }, [
                                    h('path', {
                                        d: 'M6.25 8.81819C6.51841 9.1715 6.86085 9.46384 7.25409 9.67538C7.64734 9.88692 8.08219 10.0127 8.52916 10.0442C8.97612 10.0758 9.42474 10.0123 9.84459 9.85805C10.2644 9.70385 10.6457 9.46254 10.9625 9.1505L12.8375 7.30434C13.4067 6.72403 13.7217 5.94679 13.7146 5.14003C13.7075 4.33327 13.3788 3.56154 12.7994 2.99105C12.22 2.42057 11.4362 2.09697 10.6169 2.08996C9.79751 2.08295 9.00813 2.39309 8.41875 2.95357L7.34375 4.00588',
                                        stroke: 'white',
                                        strokeWidth: '1.25',
                                        strokeLinecap: 'round',
                                        strokeLinejoin: 'round'
                                    }),
                                    h('path', {
                                        d: 'M8.74988 7.58743C8.48147 7.23412 8.13903 6.94178 7.74579 6.73023C7.35254 6.51869 6.91769 6.39289 6.47072 6.36138C6.02376 6.32986 5.57514 6.39336 5.15529 6.54756C4.73544 6.70177 4.35418 6.94308 4.03738 7.25512L2.16238 9.10127C1.59314 9.68159 1.27815 10.4588 1.28527 11.2656C1.29239 12.0723 1.62105 12.8441 2.20045 13.4146C2.77985 13.985 3.56364 14.3086 4.383 14.3157C5.20237 14.3227 5.99175 14.0125 6.58113 13.452L7.64988 12.3997',
                                        stroke: 'white',
                                        strokeWidth: '1.25',
                                        strokeLinecap: 'round',
                                        strokeLinejoin: 'round'
                                    })
                                ]),
                                h('defs', {}, [
                                    h('clipPath', {
                                        id: 'clip0_15082_397'
                                    }, [
                                        h('rect', {
                                            width: '15',
                                            height: '14.7692',
                                            fill: 'white',
                                            transform: 'translate(0 0.818359)'
                                        })
                                    ])
                                ])
                            ])
                        ]),
                        h('span', {
                            className: 'wishlist-modal__copy-text'
                        }, t('wishlist.copy'))
                    ])
                ])
            ])
        ])
    ]);
};
